module.exports = __webpack_public_path__ + "img/10.2eea2cd9.png";